import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const AdminRouteGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdminAuth = () => {
      const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn');
      const adminData = localStorage.getItem('adminData');

      if (!isAdminLoggedIn || !adminData) {
        navigate('/adminlogin');
        return;
      }

      try {
        // Verify admin data is valid JSON
        JSON.parse(adminData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Invalid admin data:', error);
        localStorage.removeItem('isAdminLoggedIn');
        localStorage.removeItem('adminData');
        navigate('/adminlogin');
        return;
      }

      setIsLoading(false);
    };

    checkAdminAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2
        }}
      >
        <CircularProgress size={60} sx={{ color: '#3A8139' }} />
        <Typography variant="h6" color="text.secondary">
          Verifying admin access...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default AdminRouteGuard;
